// extracted by mini-css-extract-plugin
export var actionButton = "_lq-0";
export var actionMenuContainer = "_lq-i";
export var bubble = "_lq-2";
export var bubbleActionMenu = "_lq-j";
export var bubbleContext = "_lq-6";
export var bubbleItems = "_lq-7";
export var customer = "_lq-3";
export var divider = "_lq-8";
export var fileList = "_lq-9";
export var hiddenComment = "_lq-o";
export var infoAbove = "_lq-a";
export var internal = "_lq-4";
export var lightActionButton = "_lq-1";
export var link = "_lq-b";
export var merchant = "_lq-5";
export var message = "_lq-c";
export var profilePicture = "_lq-e";
export var quillToolbarContainer = "_lq-f";
export var senderDate = "_lq-g";
export var senderDateCustomer = "_lq-h";
export var senderName = "_lq-d";
export var time = "_lq-k";
export var uploadedImage = "_lq-l";
export var username = "_lq-m";
export var xsmall = "_lq-n";